import React, { forwardRef } from 'react';
import classNames from 'classnames';

interface Props extends React.TdHTMLAttributes<HTMLTableCellElement> {
  colSpan?: number;
}

const TableHeaderCell = forwardRef<HTMLTableCellElement, Props>(function TableCell(props, ref) {
  const { className, children, colSpan = 1, ...other } = props;

  const baseStyle = 'px-4 py-3';

  const cls = classNames(baseStyle, className);

  return (
    <th className={cls} ref={ref} {...other} colSpan={colSpan}>
      {children}
    </th>
  );
});

export default TableHeaderCell;
